import { render, staticRenderFns } from "./UserEvaluation.vue?vue&type=template&id=74f4ba28&scoped=true&"
import script from "./UserEvaluation.vue?vue&type=script&lang=js&"
export * from "./UserEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./UserEvaluation.vue?vue&type=style&index=0&id=74f4ba28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4ba28",
  null
  
)

export default component.exports